import { useGlobalState } from './GlobalStateProvider'
import { saveFyusionSession } from '../services/fyusionService'

export default (vin, dealerGuid) => {
  const { globalState } = useGlobalState()

  return async sessionId => {
    if (!sessionId) return

    return await saveFyusionSession({
      globalState,
      params: { sessionId, vin, dealerGuid }
    })
  }
}
